<template>
  <div class="filter-wrapper">
    <div class="filter-options">
      <v-form ref="form">
        <v-row dense>
          <v-col cols="12" md="3">
            <v-select
              v-model="status"
              :items="statusList"
              label="Trạng thái mượn"
              outlined
              dense
              clearable
              hide-details
              placeholder="Tất cả trạng thái"
            />
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              v-model="date"
              type="date"
              label="Ngày mượn"
              outlined
              dense
              clearable
              hide-details
            />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              v-model="name"
              :label="isTeacher ? 'Mã phiếu hoặc mục đích mượn' : 'Người mượn hoặc mã phiếu'"
              outlined
              dense
              clearable
              hide-details
              @keyup.enter="onFilterChanged"
            />
          </v-col>
        </v-row>
      </v-form>
    </div>
    <div class="filter-submit">
      <v-btn class="search-button" @click="onFilterChanged" outlined>
        Tìm kiếm
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { textHelpers } from '@/helpers/TextHelper'

export default {
  name: 'BorrowFilter',
  data: () => ({
    status: '',
    date: null,
    name: '',
    statusList: [
      { text: 'Chờ duyệt', value: 'PENDING' },
      { text: 'Đã duyệt', value: 'APPROVED' },
      { text: 'Đang mượn', value: 'BORROWING' },
      { text: 'Quá hạn', value: 'OVERDUE' },
      { text: 'Đã trả', value: 'RETURNED' },
      { text: 'Từ chối', value: 'REJECTED' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['role']),
    isTeacher() {
      return this.role && this.role.name === 'Teacher'
    }
  },
  mounted() {
    this.onFilterChanged()
  },
  methods: {
    onFilterChanged() {
      const params = {}
      if (this.status) params.status = this.status
      if (this.date) params.borrowDate = this.date
      if (this.name) {
        if (this.isTeacher) {
          params.code_contains = textHelpers.removeSpaces(this.name)
        } else {
          params.borrowerName_contains = textHelpers.removeSpaces(this.name)
        }
      }
      this.$emit('onFilterChanged', params)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-wrapper {
  display: flex;
  gap: 24px;
  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
  .filter-options {
    flex: 1;
  }
  .filter-submit {
    margin-left: auto;
    align-self: flex-end;
  }
}
</style>
